/**
 * Created by Sasha on 4/1/2019.
 */
import {
  Component ,
  Input ,
  OnChanges , OnDestroy , OnInit ,
} from '@angular/core';



@Component({
    selector: 'simple-card',
    templateUrl: './simple-card.html',
    styleUrls: ['./simple-card.scss'],
    standalone: false
})
export class SimpleCardComponent implements OnChanges , OnDestroy , OnInit {
  @Input()  data;
  view: any[];
  animations: boolean = true;
  constructor () {}

  ngOnInit () {
  }


  ngOnChanges () {

  }


  ngOnDestroy () {

  }
}
